var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8867 18.3633C34.9933 18.3633 37.5117 15.8449 37.5117 12.7383C37.5117 9.63168 34.9933 7.11328 31.8867 7.11328C28.7801 7.11328 26.2617 9.63168 26.2617 12.7383C26.2617 15.8449 28.7801 18.3633 31.8867 18.3633Z",
    fill: "#0055FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0125 33.5H4.6875C3.4875 33.5 2.5 32.525 2.5 31.3125V19.0625C2.5 17.8625 3.4875 16.875 4.6875 16.875H6.7125V27.675C6.7125 28.1875 7.1375 28.6125 7.65 28.6125H29.1875V31.3125C29.2 32.525 28.2125 33.5 27.0125 33.5ZM4.6875 18.125C4.175 18.125 3.75 18.55 3.75 19.0625V31.3125C3.75 31.825 4.175 32.25 4.6875 32.25H27C27.5125 32.25 27.9375 31.825 27.9375 31.3125V29.8625H7.6625C6.4625 29.8625 5.475 28.875 5.475 27.675V18.125H4.6875Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2246 29.8633H28.5746V28.6133H31.2246C31.7371 28.6133 32.1621 28.1883 32.1621 27.6758V14.1758C32.1621 13.6633 31.7371 13.2383 31.2246 13.2383H7.66211C7.14961 13.2383 6.72461 13.6633 6.72461 14.1758V17.5008H5.47461V14.1758C5.47461 12.9758 6.46211 11.9883 7.66211 11.9883H31.2246C32.4246 11.9883 33.4121 12.9758 33.4121 14.1758V27.6758C33.4121 28.8883 32.4371 29.8633 31.2246 29.8633Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3125 18.3262H8.875C8.525 18.3262 8.25 18.0512 8.25 17.7012C8.25 17.3512 8.525 17.0762 8.875 17.0762H27.3125C27.6625 17.0762 27.9375 17.3512 27.9375 17.7012C27.9375 18.0512 27.65 18.3262 27.3125 18.3262Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0375 26.3875C10.6795 26.3875 11.2 25.867 11.2 25.225C11.2 24.583 10.6795 24.0625 10.0375 24.0625C9.39547 24.0625 8.875 24.583 8.875 25.225C8.875 25.867 9.39547 26.3875 10.0375 26.3875Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.2e104c0f15c7cd79e8d116fb23a5d2cc.svg";
export { ForwardRef as ReactComponent };